import { render, staticRenderFns } from "./FieldFile.vue?vue&type=template&id=01997460&scoped=true&"
import script from "./FieldFile.vue?vue&type=script&lang=js&"
export * from "./FieldFile.vue?vue&type=script&lang=js&"
import style0 from "./FieldFile.vue?vue&type=style&index=0&id=01997460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01997460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01997460')) {
      api.createRecord('01997460', component.options)
    } else {
      api.reload('01997460', component.options)
    }
    module.hot.accept("./FieldFile.vue?vue&type=template&id=01997460&scoped=true&", function () {
      api.rerender('01997460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldFile.vue"
export default component.exports